export default __webpack_public_path__ + "static/media/slondotpics.eb7ebdfc.jpg";